module.exports = __webpack_public_path__ + "static/img/lifestyle_36.012f6df5.png";